import React from 'react';
import Header from '../../components/header';
import Footer from '../../components/footer';
import SEO from '../../components/SEO';
import CTAKnap, { CTAIkoner } from '../../components/ctaknap';
import Formular from './formular/formular';
import markImage from '../../images/os/mark-pb.webp';
import './styles/kontaktside.css';

const KontaktSide = () => {
  const kontaktInfo = [
    {
      icon: <CTAIkoner.Phone />,
      title: 'Ring til os',
      info: '+45 36 17 00 00',
      subinfo: 'Hverdage 9-17',
      action: () => window.open('tel:+4536170000')
    },
    {
      icon: <CTAIkoner.Mail />,
      title: 'Send en email',
      info: 'kontakt@parlabranding.dk',
      subinfo: 'Vi svarer inden for 24 timer',
      action: () => window.open('mailto:kontakt@parlabranding.dk')
    },
    {
      icon: <CTAIkoner.FileText />,
      title: 'Få et tilbud',
      info: 'Brug vores prisudregner',
      subinfo: 'Få svar på 5 minutter',
      action: () => window.location.href = '/priser#prisudregner'
    }
  ];

  return (
    <div className="kontakt-side">
      <SEO 
        title="Kontakt Parla Branding | Lad os Starte en Dialog"
        description="Klar til at diskutere dit projekt? Kontakt os for en uforpligtende samtale om, hvordan vi kan skabe en hjemmeside, der leverer værdi for din forretning."
        keywords="kontakt webbureau, hjemmeside dialog, uforpligtende samtale, projekt diskussion, hjemmeside værdi, webdesign samtale"
        url="https://parlabranding.dk/kontakt"
        type="website"
        canonicalUrl="https://www.parlabranding.dk/kontakt"
      />
      <Header />
      
      {/* Hero sektion */}
      <section className="kontakt-hero">
        <div className="kontakt-hero-background">
          <div className="kontakt-hero-overlay"></div>
        </div>
        <div className="container">
          <div className="kontakt-hero-content">
            <div className="kontakt-hero-text">
              <span className="kontakt-hero-badge">
                <CTAIkoner.Mail />
                Kontakt Os
              </span>
              <h1 className="kontakt-hero-title">
                Lad os tage en <span className="kontakt-hero-accent">uforpligtende snak</span> om jeres projekt
              </h1>
              <p className="kontakt-hero-description">
                Har I en konkret idé, eller er I bare nysgerrige på, hvordan en ny hjemmeside kan styrke jeres forretning? Uanset hvor I er i processen, er I velkomne til at tage fat i os. Udfyld formularen, send en mail eller giv os et kald, så vender vi tilbage hurtigst muligt. Kaffen er klar.
              </p>
              <div className="kontakt-hero-actions">
                <CTAKnap
                  variant="primary"
                  size="large"
                  href="#kontakt-form"
                  icon={<CTAIkoner.ArrowRight />}
                >
                  Send os en besked
                </CTAKnap>
                <CTAKnap
                  variant="outline"
                  size="large"
                  href="tel:+4536170000"
                  icon={<CTAIkoner.Phone />}
                >
                  Ring til os
                </CTAKnap>
              </div>
            </div>
            <div className="kontakt-hero-visual">
              <div className="kontakt-hero-image">
                <img 
                  src={markImage} 
                  alt="Mark fra Parla Branding" 
                  className="kontakt-mark-image"
                />
                <div className="person-badge">
                  <div className="person-name">Mark</div>
                  <div className="person-title">Vores CEO</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Kontakt info kort */}
      <section className="kontakt-info-section">
        <div className="container">
          <div className="kontakt-info-grid">
            {kontaktInfo.map((item, index) => (
              <div 
                key={index} 
                className="kontakt-info-card"
                onClick={item.action}
              >
                <div className="kontakt-info-icon">
                  {item.icon}
                </div>
                <div className="kontakt-info-content">
                  <h3 className="kontakt-info-title">{item.title}</h3>
                  <p className="kontakt-info-main">{item.info}</p>
                  <p className="kontakt-info-sub">{item.subinfo}</p>
                </div>
                <div className="kontakt-info-arrow">
                  <CTAIkoner.ArrowRight />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Kontakt form sektion */}
      <section id="kontakt-form" className="kontakt-form-section">
        <div className="container">
          <div className="kontakt-form-layout">
            <div className="kontakt-form-info">
              <h2 className="kontakt-form-title">
                Send os en besked
              </h2>
              <p className="kontakt-form-description">
                Fortæl os om dit projekt, så kan vi give dig den bedste løsning. Jo mere du fortæller, desto bedre kan vi hjælpe dig.
              </p>
              
              <div className="kontakt-benefits">
                <div className="kontakt-benefit">
                  <div className="benefit-icon">
                    <CTAIkoner.Check />
                  </div>
                  <div className="benefit-text">
                    <h4>Gratis konsultation</h4>
                    <p>Vi giver altid en grundig og gratis konsultation</p>
                  </div>
                </div>
                <div className="kontakt-benefit">
                  <div className="benefit-icon">
                    <CTAIkoner.Clock />
                  </div>
                  <div className="benefit-text">
                    <h4>Hurtig respons</h4>
                    <p>Vi svarer på alle henvendelser inden for 24 timer</p>
                  </div>
                </div>
                <div className="kontakt-benefit">
                  <div className="benefit-icon">
                    <CTAIkoner.Star />
                  </div>
                  <div className="benefit-text">
                    <h4>Skræddersyet løsning</h4>
                    <p>Hver løsning tilpasses dine specifikke behov</p>
                  </div>
                </div>
              </div>
            </div>

            <Formular />
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default KontaktSide;
